import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles, Box, Typography } from "@material-ui/core";
import NavBar from "./NavBar";
import TopBar from "./TopBar";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "#2D1639",
    display: "flex",
    height: "100%",
    overflow: "hidden",
    width: "100%",
  },
  wrapper: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    paddingTop: 80,
    minHeight: "calc(100vh - 80px)",
    backgroundColor: theme.palette.background.darkgrey,

    // backgroundColor: "#1A2C38",
    [theme.breakpoints.up("lg")]: {
      paddingLeft: 200,
    },
  },
  contentContainer: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    background: theme.palette.primary.paper,
  },
  content: {
    flex: "1 1 auto",
    height: "100%",
    width: "100%",
    position: "relative",
    WebkitOverflowScrolling: "touch",
    background: "#240E25",

    "& .BoxMain": {
      paddingTop: "59px",
      paddingLeft: "8px",
      paddingRight: "8px",
      [theme.breakpoints.only("xs")]: {
        paddingTop: "50px",
        paddingLeft: "12px",
        paddingRight: "12px",
      },
    },
  },
  secondTopbar: {
    position: "fixed",
    zIndex: 111,
    top: "76px",
    width: "100%",
    padding: "15px 15px 15px 36px",
    background: "#341C4A",
    [theme.breakpoints.down("xs")]: {
      padding: "15px 15px 15px 13px",
    },
    "& .ContentBox": {
      display: "flex",
      alignItems: "center",
    },
    "& .ContentBoxSub": {
      marginLeft: "60px",
      [theme.breakpoints.only("xs")]: {
        marginLeft: "55px",
      },

      "& h5": {
        background: "linear-gradient(180deg, #FDA645 22.32%, #FF00CD 77.68%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
        textFillColor: "transparent",
        fontWeight: "600",
      },
    },
  },
}));

const DashboardLayout = ({ children }) => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <>
      <div className={classes.root}>
        <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
        <Box className={classes.secondTopbar}>
          <Box display="flex" className="ContentBox">
            <Box style={{ color: "#A6ACD6" }}>Manage Account Activities</Box>
            <Box className="ContentBoxSub">
              <Typography variant="h5">
                {window.location.pathname === "/dashboard"
                  ? "Dashboard"
                  : window.location?.pathname === "/Account"
                  ? "Account"
                  : window.location?.pathname === "/wallet"
                  ? "Wallet"
                  : window.location?.pathname === "/transaction"
                  ? "Transaction"
                  : window.location?.pathname === "/login-history"
                  ? "Login"
                  : ""}
              </Typography>
            </Box>
          </Box>
        </Box>

        <NavBar
          onMobileClose={() => setMobileNavOpen(false)}
          openMobile={isMobileNavOpen}
        />
        <div className={classes.wrapper}>
          <div className={classes.contentContainer}>
            <div className={classes.content} id="main-scroll">
              <Box className="BoxMain">{children}</Box>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
